<template>
  <a-button @click="toggle">
    {{ fullscreen ? 'Выйти из полного экрана' : 'На весь экран' }}
  </a-button>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { message } from 'ant-design-vue';
import { toggleQaFullscreen } from './qaFullscreen';

const fullscreen = ref(false);
const sync = () => { fullscreen.value = Boolean(document.fullscreenElement); };
const toggle = () => toggleQaFullscreen().catch(() => message.error('Не удалось включить полноэкранный режим'));
onMounted(() => document.addEventListener('fullscreenchange', sync));
onBeforeUnmount(() => document.removeEventListener('fullscreenchange', sync));
</script>

<style>
:fullscreen .qa-workspace { height: 100vh; }
:fullscreen .qa-workspace__body { min-height: 0; }
</style>
